<div class="p-4">
    <ng-container *ngIf="securityError; else authenticated">
        YOU DO NOT HAVE PERMISSIONS TO ACCESS SECURITY PROFILES.
    </ng-container>
    <ng-template #authenticated>
        <mat-form-field class="w-80" >
            <mat-label>Select Security Profiles to Compare</mat-label>
            <mat-select [formControl]="selectedProfiles" multiple (selectionChange)="updateDisplayedColumns()">
                <mat-option *ngFor="let profile of allProfiles" [value]="profile.securityProfileId">
                    {{ profile.SecurityProfileName }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <br/>
        <ng-container *ngIf="dataSource.data.length>0">
            <mat-slide-toggle [(ngModel)]="showDifferences" (change)="toggleChanges()">
                Only Show Differences
            </mat-slide-toggle>
            <br/>
            <br/>
            <button mat-raised-button color="primary" aria-label="Download Skills"
                    (click)="downloadMatrix()">
                <mat-icon >download</mat-icon>
                Download Matrix
            </button>
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 w-full mt-4 difference-matrix">
                <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
                    <th mat-header-cell *matHeaderCellDef>{{ formatHeaderTitle(column) }}</th>
                    <td mat-cell *matCellDef="let row" [ngClass]="{'changed': isChanged(row, column)}">
                        <!--                <input *ngIf="column !== 'field'" [(ngModel)]="row[column]" (change)="editValue(row, column, $event)" class="border p-1 w-full"/>-->
                        <span *ngIf="column !== 'field' && row[column]">
                    <ng-container *ngFor="let line of getvalueArray(row[column])">{{ line }}<br/></ng-container>
                </span>
                        <span *ngIf="column === 'field'">{{ row[column] }}</span>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" ></tr>
            </table>
        </ng-container>
    </ng-template>
    <!--    <button (click)="saveChanges()" class="save-btn mt-4" [disabled]="isSaving">{{ isSaving ? 'Saving...' : 'Save Changes' }}</button>-->
</div>
